import { Chip, Stack, TextField } from "@mui/material"

const Notes = ({quote, patchQuote, removeTag, readOnly = false}) => {
    return (
        <div className="hive-quote-notes" style={{display: "flex", flexWrap: "wrap", justifyContent: "center"}}>
            <div className="col-12 col-sm-8" style={{margin: "0.5em"}}>
                <TextField
                    fullWidth
                    label="Main Header"
                    value={quote?.headers?.mainHeader || ""}
                    onChange={(e) => patchQuote({ "headers.mainHeader": e.target.value })}
                    disabled={readOnly}
                />
            </div>
            <div className="col-12 col-sm-8" style={{margin: "0.5em"}}>
                <TextField
                    fullWidth
                    label="Secondary Header"
                    value={quote?.headers?.secondaryHeader || ""}
                    onChange={(e) => patchQuote({ "headers.secondaryHeader": e.target.value })}
                    disabled={readOnly}
                />
            </div>
            <div className="col-12 col-sm-8" style={{margin: "0.5em"}}>
                <TextField
                    fullWidth
                    label="Final Header"
                    value={quote?.headers?.finalHeader || ""}
                    onChange={(e) => patchQuote({ "headers.finalHeader": e.target.value })}
                    disabled={readOnly}
                />
            </div>
            {quote?.tags && (
                <div className="col-12 col-sm-8" style={{margin: "0.5em"}}>
                    <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ margin: "0.5em" }}>
                        {quote.tags.map((tag) => (
                            <Chip
                                className="hive-quote-tag-chip"
                                key={tag}
                                label={tag}
                                color="primary"
                                variant="outlined"
                                onDelete={readOnly ? undefined : () => removeTag(tag)}
                            />
                        ))}
                    </Stack>
                </div>
            )}
        </div>
    )
}

export default Notes
